import { realtorComApi } from "api/realtorCom";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { Layout } from "providers/Layout";
import { useAuthContext } from "providers/Auth";
import { IntegrationId } from "views/settings-integration/components/AddIntegrationModal/types";
import { FeedAutoAddCard } from "views/settings-integration/integrations/shared/FeedAutoAddCard";
import { FeedListingsCard } from "views/settings-integration/integrations/shared/FeedListingsCard";
import { IntegrationDetailHeader } from "views/settings-integration/integrations/shared/IntegrationDetailHeader";
import { toast } from "react-toastify";
import { getErrorMessage } from "utils/error";

export const RealtorComView = () => {
  const navigate = useNavigate();
  const { refreshPartnerData } = useAuthContext();

  const { mutate: disconnectRealtorCom, isPending: isDisconnecting } =
    useMutation({
      mutationKey: ["REALTOR_COM", "DELETE"],
      mutationFn: () => realtorComApi.disconnect(),
      onSuccess: () => {
        toast.success("Realtor.com integration disconnected successfully");
        refreshPartnerData();
        navigate("/settings/integration");
      },
      onError: (err) => {
        toast.error(getErrorMessage(err));
      }
    });

  return (
    <Layout
      header={
        <IntegrationDetailHeader
          id={IntegrationId.REALTOR_COM}
          name="Realtor.com"
          path="/settings/integration/realtor-com"
          onDisconnect={() => disconnectRealtorCom()}
          isDisconnecting={isDisconnecting}
        />
      }
    >
      <div className="space-y-6">
        <FeedAutoAddCard feed="realtor_com" feedLabel="Realtor.com" />
        <FeedListingsCard feed="realtor_com" feedLabel="Realtor.com" />
      </div>
    </Layout>
  );
};
